module.exports = __webpack_public_path__ + "static/m-GMartinez-b043489bb2ba09ed35b3648ad9089fcd.jpg";